<template>
    <div class="close-account-container">
        <veui-form
            ref="form"
            :data="formData"
            @submit="handleSubmit"
        >
            <div class="form">
                <div class="title">注销律临资质申请</div>
                <div class="upload-box">
                    <div class="label">上传律师执业证</div>
                    <div class="right-box">
                        <div class="tip">照片清晰可看见执业证号、姓名、身份证号</div>
                        <veui-field
                            name="lawyerLicense"
                            :rules="lawyerLicenseRules"
                        >
                            <veui-uploader
                                v-model="formData.lawyerLicense"
                                picker-label="上传执业证"
                                picker-icon="plus"
                                type="image"
                                :max-count="2"
                                :action="uploadUrl"
                                accept=".jpg,.png,.jpeg,.gif,.wbmp,.xbm"
                                max-size="1024kb"
                                :convert-response="convertResponse"
                            >
                            </veui-uploader>
                        </veui-field>
                    </div>
                </div>
                <div class="upload-box">
                    <div class="label">上传手写授权书</div>
                    <div class="right-box">
                        <div class="tip">请提供手写签字证明，为律师本人申请资质注销</div>
                        <veui-field
                            name="lawyerAuthLetter"
                            :rules="lawyerAuthLetterRules"
                        >
                            <veui-uploader
                                v-model="formData.lawyerAuthLetter"
                                picker-label="上传授权书"
                                picker-icon="plus"
                                type="image"
                                :max-count="2"
                                :action="uploadUrl"
                                accept=".jpg,.png,.jpeg,.gif,.wbmp,.xbm"
                                max-size="1024kb"
                                :convert-response="convertResponse"
                            >
                            </veui-uploader>
                        </veui-field>
                    </div>
                </div>
            </div>
            <template #actions>
                <div class="bottom-bar">
                    <button
                        class="confirm"
                        type="submit"
                        :disabled="isUploaded"
                    >
                        提交申请
                    </button>
                    <div class="back" @click="back">上一页</div>
                </div>
            </template>
        </veui-form>
        <veui-dialog
            ui="narrow"
            title="上传申请审核中"
            :open.sync="dialogOpen"
        >
            审核结果将在1-3个工作日以短信的形式通知您~
            <template #foot>
                <veui-button
                    class="know-btn"
                    ui="primary"
                    @click="handleKnow"
                >
                    知道了
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
import {Uploader, Form, Field, Dialog, Button} from 'veui';
import {uploadUrl} from '@/config/upload';
import {postFeedback} from '@/request/ufo';
import {mapState} from 'vuex/dist/vuex.common.js';

export default {
    name: 'CloseAccountPage',

    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-uploader': Uploader,
        'veui-dialog': Dialog,
        'veui-button': Button
    },

    data() {
        return {
            uploadUrl,
            dialogOpen: false,
            lawyerLicenseRules: [{
                name: 'required',
                message: '请上传律师执业证'
            }],
            lawyerAuthLetterRules: [{
                name: 'required',
                message: '请上传手写授权书'
            }],
            formData: {
                lawyerLicense: [], // 律师执业证
                lawyerAuthLetter: [] // 手写授权书
            },
            isUploading: false, // 是否上传中
            isUploaded: false // 是否上传完毕
        };
    },

    computed: {
        ...mapState({
            userInfo: state => state.lawStore?.userInfoNew
        })
    },

    methods: {
        // 上传处理
        convertResponse(data) {
            const {bos_url, name} = data?.data || {};
            return {
                success: data && data.code === '0',
                name: name,
                src: bos_url,
                message: data.msg
            };
        },

        // 提交
        async handleSubmit() {
            if (this.isUploading) {
                return;
            };

            this.isUploading = true;
            const imgUrlList = [...this.formData.lawyerLicense,
                                ...this.formData.lawyerAuthLetter] .map(item => item.src);
            const {name, uk} = this.userInfo.lawyer_info;
            try {
                const res = await postFeedback(`${name}(${uk})律师申请注销律临资质`, imgUrlList);
                if (res.errno === 0) {
                    this.dialogOpen = true;
                    this.isUploaded = true;
                }
                else {
                    this.$toast.error(res.errmsg);
                }
            }
            catch (error) {
                this.$toast.error('提交失败，请重试！');
            }
            finally {
                this.isUploading = false;
            }
        },

        // 返回
        back() {
            this.$emit('changeCloseAccountPage', false);
        },

        // 我知道了
        handleKnow() {
            this.dialogOpen = false;
            this.back();
        }
    }
};
</script>

<style lang="less" scoped>
.close-account-container {
    .form {
        padding: 30px;
        background: #fff;
        border-radius: 8px;

        .title {
            color: #1e1f24;
            font-family: "PingFang SC";
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 18px;
        }

        .upload-box {
            margin-top: 30px;
            display: flex;

            .label {
                color: #1e1f24;
                font-family: "PingFang SC";
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px;
            }

            .right-box {
                margin-left: 18px;

                .tip {
                    color: #848691;
                    font-family: "PingFang SC";
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 18px;
                }

                .veui-uploader {
                    margin-top: 12px;
                }
            }
        }
    }

    ::v-deep .veui-field {
        margin: 0;
    }

    ::v-deep .veui-form-actions {
        margin: 0;
        padding: 0;
    }

    .bottom-bar {
        margin-top: 24px;
        padding: 30px;
        display: flex;
        background: #fff;
        border-radius: 8px;

        .confirm,
        .back {
            display: flex;
            height: 40px;
            width: 112px;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            font-family: "PingFang SC";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            cursor: pointer;
        }

        .confirm {
            color: #fff;
            background-color: #05f;

            &[disabled] {
                opacity: .5;
            }
        }

        .back {
            margin-left: 15px;
            color: #05f;
            background-color: #fff;
            border: #05f solid 1px;
        }
    }
}

::v-deep .veui-dialog-content-foot {
    display: flex;
    justify-content: center;

    .know-btn {
        width: 180px;
        height: 40px;
    }
}
</style>